module.exports = __webpack_public_path__ + "static/flags/JN-7d860cee72c1df7e92993d5991979e6b.gif";